function isHttp500Error(response) {
  let codeNumber = response;
  if (typeof codeNumber === 'object') {
    codeNumber = response.status;
  }
  return (codeNumber > 499 && codeNumber < 600);
}

export default isHttp500Error;
